import { render, staticRenderFns } from "./CmgToast.vue?vue&type=template&id=2a0dd9da&scoped=true&lang=pug"
import script from "./cmg-toast.ts?vue&type=script&lang=ts&external"
export * from "./cmg-toast.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgToast.vue?vue&type=style&index=0&id=2a0dd9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0dd9da",
  null
  
)

export default component.exports